
<div class="outer" >
<div class="container" >

    <div class="title into" style="--order: 1"></div>
    <div class=top>
        <div class="top-left">
            <div style="--order: 2" class="verse"></div>
            <div style="--order: 3" class="greyblob"></div>
        </div>
        <div style="--order: 4" class="question"></div>

    </div>

    <div style="height: 100px"></div>

    <div class=blanks>
        <div style="--order: 5" class="sen-s"></div> 
        <div style="--order: 6" class="sen-l"></div>
        <div 
            style="--order: 7"
            [attr.id]="vpids[0]"
            class="blank"></div>
        <div style="--order: 8" class="sen-s"></div>
        <div style="--order: 9" class="sen-m"></div>
        <div
            style="--order: 10"
            [attr.id]="vpids[1]"
            class="blank"></div>
        <div 
            style="--order: 11"
            [attr.id]="vpids[2]"
            class="blank"></div>
        <div class="sen-m" style="--order: 11"></div>
        <div 
              style="--order: 12"
            [attr.id]="vpids[3]"
            class="blank"></div>
        <div class="sen-s" style="--order: 12"></div>
    </div>

    <div class="cloud">
        <div  style="--order: 13"  class="option-1"></div>
        <div  style="--order: 14"  class="option-3"></div>
        <div  style="--order: 15"  class="option-2"></div>
        <div  style="--order: 16"  class="option-2"></div>
        <div  style="--order: 17"  class="option-1"></div>
        <div  style="--order: 18"  class="option-3"></div>
    </div>
    
    <div class="bottom">
        <div style="--order: 19" class="bottom-button"></div>
        <div style="--order: 20" class="bottom-button"></div>
    </div>

</div>
</div>